import React from 'react';

const OnchainMetricsCards = ({ data, isLoading }) => {
  const styles = {
    primaryBg: "#ffffff",
    secondaryBg: "#DDE2EE",
    textPrimary: "#0f172a",
    textSecondary: "#666666",
    accentColor: "#1d0c46",
    borderColor: "#DDE2EE"
  };

  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M';
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    return num.toLocaleString();
  };

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        {[1, 2].map((i) => (
          <div
            key={i}
            className="p-4 md:p-6"
            style={{ backgroundColor: styles.primaryBg, border: `1px solid ${styles.borderColor}` }}
          >
            <div className="animate-pulse">
              <div className="flex gap-4">
                <div className="flex-1">
                  <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                  <div className="h-8 bg-gray-200 rounded w-1/2"></div>
                </div>
                <div className="flex-1">
                  <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                  <div className="h-8 bg-gray-200 rounded w-1/2"></div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      {/* Card 1: Wallets */}
      <div
        className="p-4 md:p-6"
        style={{ backgroundColor: styles.primaryBg, border: `1px solid ${styles.borderColor}` }}
      >
        <div className="mb-4 text-center">
          <h3 
            className="text-xs font-normal"
            style={{ color: styles.textSecondary, fontFamily: 'Raleway, sans-serif' }}
          >
            Wallets
          </h3>
        </div>
        <div className="flex gap-4">
          <div className="flex-1 flex flex-col items-center justify-center text-center">
            <div
              className="text-2xl font-semibold mb-1"
              style={{ color: styles.accentColor, fontFamily: 'Raleway, sans-serif' }}
            >
              {formatNumber(data?.totalUniqueWallets || 0)}
            </div>
            <div
              className="text-xs"
              style={{ color: styles.textSecondary, fontFamily: 'Raleway, sans-serif' }}
            >
              Total
            </div>
          </div>
          <div className="flex-1 flex flex-col items-center justify-center text-center">
            <div
              className="text-2xl font-semibold mb-1"
              style={{ color: styles.accentColor, fontFamily: 'Raleway, sans-serif' }}
            >
              {formatNumber(data?.activeWalletsLast30Days || 0)}
            </div>
            <div
              className="text-xs"
              style={{ color: styles.textSecondary, fontFamily: 'Raleway, sans-serif' }}
            >
              Active Last 30 Days
            </div>
          </div>
        </div>
      </div>

      {/* Card 2: Transactions */}
      <div
        className="p-4 md:p-6"
        style={{ backgroundColor: styles.primaryBg, border: `1px solid ${styles.borderColor}` }}
      >
        <div className="mb-4 text-center">
          <h3 
            className="text-xs font-normal"
            style={{ color: styles.textSecondary, fontFamily: 'Raleway, sans-serif' }}
          >
            Transactions
          </h3>
        </div>
        <div className="flex gap-4">
          <div className="flex-1 flex flex-col items-center justify-center text-center">
            <div
              className="text-2xl font-semibold mb-1"
              style={{ color: styles.accentColor, fontFamily: 'Raleway, sans-serif' }}
            >
              {formatNumber(data?.totalTransactionCount || 0)}
            </div>
            <div
              className="text-xs"
              style={{ color: styles.textSecondary, fontFamily: 'Raleway, sans-serif' }}
            >
              Total
            </div>
          </div>
          <div className="flex-1 flex flex-col items-center justify-center text-center">
            <div
              className="text-2xl font-semibold mb-1"
              style={{ color: styles.accentColor, fontFamily: 'Raleway, sans-serif' }}
            >
              {formatNumber(data?.transactionCountLast30Days || 0)}
            </div>
            <div
              className="text-xs"
              style={{ color: styles.textSecondary, fontFamily: 'Raleway, sans-serif' }}
            >
              Last 30 Days
            </div>
          </div>
          <div className="flex-1 flex flex-col items-center justify-center text-center">
            <div
              className="text-2xl font-semibold mb-1"
              style={{ color: styles.accentColor, fontFamily: 'Raleway, sans-serif' }}
            >
              {formatNumber(data?.transactionCountLast7Days || 0)}
            </div>
            <div
              className="text-xs"
              style={{ color: styles.textSecondary, fontFamily: 'Raleway, sans-serif' }}
            >
              Last 7 Days
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnchainMetricsCards;

